import classNames from 'classnames';

import styles from './_index.module.scss';

export interface SidebarProps extends React.HTMLAttributes<HTMLElement> {}

const Sidebar = <T extends React.ElementType>({
  as,
  className,
  ...props
}: PolymorphicProps<T> & SidebarProps) => {
  const Component = as || 'div';
  return <Component className={classNames(styles['sidebar'], className)} {...props} />;
};

export default Sidebar;
